// ========== plugin import ======= //
import React, { useState } from 'react'
// ========= component import ========== //
import ProductSetup from './component/productSetup/ProductSetup';
import FeatureSetup from './component/featureSetup/FeatureSetup';
import ProductFeatureAssociation from './component/productFeatureAssociation/ProductFeatureAssociation';
import ProductFeatureAssociationSetup from './component/productFeatureAssociationSetup/ProductFeatureAssociationSetup';
const Step3 = (props) => {
    const {
        formValidateError,
        formData,
    } = props;
    // --------- define all state ------- //
    const [productIsChange, setProductIsChange] = useState(false);
    const [featureIsChange, setFeatureIsChange] = useState(false);
    const [pfAssChange, setPfAssChange] = useState(false);
    // ----- product ----- //
    const productSetupApiIsCallHandler = (productChange) => {
        setProductIsChange(productChange)
    }
    // ------ feature ------ //
    const featureSetupApiIsCallHandler = (featureChange) => {
        setFeatureIsChange(featureChange)
    }
    // ------ product_feature_association_data ---- //
    const productFeatureAssChangeHandler = (pfAssChange) => {
        setPfAssChange(pfAssChange)
    }
    const isRefreshHandler = (refresh) => {
        setProductIsChange(refresh)
        setFeatureIsChange(refresh)
    }
    const prAssRefreshHandler = (refresh) => {
        setPfAssChange(refresh)
    }


    const infoPopupData = {
        'product_setup' : {
            'title' : 'Product setup',
            'info' : `Use this Action Type for providing information in an interactive mode to your customers. It can be a Product or a Service that you provide. For example, your customer may inquire about the EV you sell or a Hotel Accommodation.`,
        },
    }
    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }


    return (
        <>
            <div>
                <ProductSetup
                    formValidateError = {formValidateError}
                    formData = {formData}
                    isInfoOpenHandler={props.isInfoOpenHandler}
                    onInputChange={props.onInputChange}
                    productSetupApiIsCall={productSetupApiIsCallHandler}
                    infoOpenOnCLick={infoOpenOnCLick}
                />
            </div>
            <div>
                <FeatureSetup
                    formValidateError = {formValidateError}
                    formData = {formData}
                    isInfoOpenHandler={props.isInfoOpenHandler}
                    onInputChange={props.onInputChange}
                    featureSetupApiIsCall={featureSetupApiIsCallHandler}
                />
            </div>
            <div>
                <ProductFeatureAssociation
                    formValidateError = {formValidateError}
                    formData = {formData}
                    isInfoOpenHandler = {props.isInfoOpenHandler}
                    onInputChange={props.onInputChange}
                    productIsChange={productIsChange}
                    featureIsChange={featureIsChange}
                    isRefresh={isRefreshHandler}
                    productFeatureAssChange={productFeatureAssChangeHandler}
                />
            </div>
            <div>
                <ProductFeatureAssociationSetup
                    formValidateError = {formValidateError}
                    formData = {formData}
                    isInfoOpenHandler = {props.isInfoOpenHandler}
                    onInputChange={props.onInputChange}
                    productIsChange={productIsChange}
                    featureIsChange={featureIsChange}
                    isRefresh={isRefreshHandler}
                    pfAssChange={pfAssChange}
                    prAssRefresh={prAssRefreshHandler}
                />
            </div>
        </>
    )
}

export default Step3
